// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//cnpm install --save axios babel-polyfill keycode muse-ui normalize.css vuex zepto
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import dialogs from "./views/modules/dialogs.vue";
import globalLoading from "./views/modules/globalLoad.vue";
import customerServices from "./views/modules/customer-services.vue";

import api from "./apis";
import router from "./router";
import store from "./store/store";
import utils from "./utils";
import "../static/flexible.js";
import i18n from "./language/index.js";
import $ from "zepto";
// import VueMaterial from 'vue-material'
import filter from "./filter.js";
// Vue.use(VueMaterial)
Vue.prototype.$api = api;
import keepStatus from "./views/modules/keep-status.vue";
Vue.component("keep-status", keepStatus);
// import jquery from 'jquery'
// Vue.config.productionTip = false
//Vue.prototype.$http = axios;
//Vue.use(lodash)
// var history_routers = ['/'];
let home = router.options.routes[0];
let historys = [{
  path: home.path,
  name: home.name
}];
Vue.prototype.getImgs = function (path, type) {
  let reg = /^app./g;
  let hostname = window.location.hostname;
  if (!reg.test(hostname) || hostname == "app.ecs.net") {
    hostname = 'app.lchtrip.com';
  }
  if (!type || type == 'img') {
    return `/static/${hostname.replace(/\./g,'')}/imgs/${path}`
  } else {
    return `url(/static/${hostname.replace(/\./g,'')}/imgs/${path})`
  }
}
// function checkState(isTips, store, to, callback) {
//     let requiresAuth = _.find(to.matched, o => o.meta.requiresAuth);
//     let isRedirect = requiresAuth !== undefined;
//     if (!store.getters.isLogin) {
//         callback(isRedirect);
//         return;
//     } else if (store.getters.ticketInfo.UserID !== undefined) {
//         callback(false);
//         return;
//     }
//     if (!isRedirect) {
//         callback(false);
//     }
//     return store.dispatch('loadTicketInfo', {
//         failTips: false
//     }).then(function(response) {
//         if (response.data.isSucc === true) {
//             if (isRedirect)
//                 callback(false);
//             return response;
//         }
//         return store.dispatch("logout").then(function() {
//             if (isRedirect)
//                 callback(isRedirect);
//         });
//     }).catch(function(response) {
//         if (isRedirect)
//             callback(isRedirect);
//     });
// }

function isInView(target) {
  let bottom = target.getBoundingClientRect().bottom;
  // 可视区域高度 - 元素底部到窗口顶部的高度 < 0, 则说明被键盘挡住了
  if (window.innerHeight - bottom < 0) {
    return false;
  }
  return true;
}
var $window = $(window);
var wHeight = $window.height();
$(document).on("click", "[type=text],[type=password],textarea", function () {
  let $target = $(event.target);
  let target = event.target;
  let i = 0;
  let ctl = setInterval(function () {
    if (!isInView(target)) {
      if (target.scrollIntoView) {
        target.scrollIntoView(false);
      } else {
        let height = $target.first().get(0).offsetTop;
        $(".content").animate({
          scrollTop: height
        });
      }
    }
    i++;
    if (i > 5) clearInterval(ctl);
  }, 100);
});

function checkState(isTips, store, to, callback) {
  let requiresAuth = _.find(to.matched, o => o.meta.requiresAuth);
  let isRedirect = requiresAuth !== undefined;
  if (document.cookie.indexOf("SfsSes") == -1 && !sessionStorage.getItem("SfsSes")) {
    callback(isRedirect);
    return;
  } else if (store.getters.ticketInfo.UserID !== undefined) {
    callback(false);
    return;
  }
  if (!isRedirect) {
    callback(false);
  }
  return store.dispatch("loadTicketInfo", {
      failTips: false
    })
    .then(function (response) {
      if (response.data.isSucc === true) {
        if (isRedirect) callback(false);
        return response;
      }
      return store.dispatch("logout").then(function () {
        if (isRedirect) callback(isRedirect);
      });
    })
    .catch(function (response) {
      if (isRedirect) callback(isRedirect);
    });
}

router.beforeEach((to, from, next) => {
  let deviceInfo = localStorage.deviceInfo ? localStorage.deviceInfo : undefined
  if (to.path == "/" && (!deviceInfo || deviceInfo == '{}')) {
    localStorage.setItem("deviceInfo", JSON.stringify(to.query))
  }
  checkState(false, store, to, function (isRedirect) {
    if (isRedirect === true) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
      return;
    }
    var lastHistory = historys[historys.length - 1];
    if (from.path == lastHistory.path) {
      lastHistory.scrollTop = $(".page").scrollTop();
    }
    next();
  });
});
Date.prototype.toJSON = function () {
  return utils.DateFormat(this, "yyyy-MM-dd HH:mm:ss")
}

window.addEventListener("popstate", function (e) {
  console.log(e.state.target)
  if (e.state && e.state.target == "index") {
    window.history.pushState({target:  "index",}, "", "/");
  }
}, false);

// var title = document.title;
const zeroWidthSpace=`​`;
const app = new Vue({
  i18n,
  router,
  store,
  data() {
    return {
      transitionName: "slide-left",
      historys: [{
        path: home.path,
        name: home.name
      }],
      // FeatureCodes: null,
      versionlist: {

      }
    };
  },
  computed: {
    lch_device_info() {
      if (window.lch_device_info) {
        return window.lch_device_info
      } else {
        return undefined
      }
    },
    keepAlive() {
      var keepAlive = this.historys
        .map(function (router) {
          let str = (router.name || router.path).replace(/\//g, "");
          return str;
        })
        .join(",");
      return keepAlive;
    },
    FeatureCodes(){
      let ticketInfo = this.$store.getters.ticketInfo||{};
      return (ticketInfo.FeatureCodes||[]).map(o=>o.toLowerCase());
    },
    featureClasss(){
      let clazz=[];
      if(window.lch_device_info!=undefined)
      {
        clazz.push('appInner');
      }
      if(window.sessionStorage.FeatureCodes>-1)
      {
        clazz.push('HideHeader');
      }
      let doc = document;
      if(this.FeatureCodes.indexOf("hidelogo")>-1)
      {
        if(doc.title.length>1)
        {
          doc.title = zeroWidthSpace;
        }
        clazz.push('hideLogo');
      }else{
        setTimeout(() => {
          if(this.FeatureCodes.indexOf("hidelogo")==-1)
          {
            doc.title=title;
          }
        }, 5000);
      }
      if(this.FeatureCodes.indexOf("hidebtrip")>-1)
      {
        clazz.push('hideBtrip');
      }
      if(this.FeatureCodes.indexOf("hidelogs")>-1)
      {
        clazz.push('hideLogs');
      }
      return clazz.join(' ');
    }
  },
  watch: {
    $route(to, from) {
      let __self = this;
      // console.log(to.fullPath)
      // let historys = this.historys;
      // if (historys[historys.length - 1].path == to.path)
      //   return;
      // var isBack = historys.length < 2 ? false : to.path == historys[historys.length - 2].path;
      // if (isBack) {
      //   historys.pop();
      // } else {
      //   let mc = _.last(to.matched);
      //   let name = mc && mc.components && mc.components.default && mc.components.default.name || to.name;
      //   historys.push({
      //     path: to.path,
      //     name: name
      //   });
      // }
      let historys = __self.historys;
      let last = _.last(historys);
      if (last.fullPath == to.fullPath) return;
      let isBack = historys.length >= 2 && to.fullPath == _.first(_.takeRight(historys, 2)).fullPath;
      let isReplace = historys.length == 2 && _.startsWith(from.fullPath, to.fullPath);
      if (isBack || isReplace) {
        historys.pop();
      }
      if (!isBack || isReplace) {
        let length = history.length;
        let replaceBefore = _.find(historys, o => o.length == length && o.path == to.path);
        if (!replaceBefore) {
          historys.push({
            path: to.path,
            name: name,
            fullPath: to.fullPath,
            length: length
          });
        } else {
          replaceBefore.fullPath = to.fullPath;
        }
      }
      __self.transitionName = isBack ? "slide-right" : historys.length > 2 ? "slide-left" : "";
    },
    '$i18n.locale'(newVal) {
      if (newVal) {
        this.SaveCookie(newVal)
      }
    },
  },
  created() {
    let __self = this;
    __self.$api.base.gettripcomVersion({}).then(json => {
      if (json.data.isSucc) {
        __self.versionlist = json.data.result;
      }
    })
  },
  mounted() {
    let __self = this;
    if (!window.sessionStorage.FeatureCodes) {
      window.sessionStorage.FeatureCodes = location.search.indexOf('HideHeader');
    }
    __self.SaveCookie(__self.$i18n.locale)
    $(document).on("click", ".softKeyboardHide", function (e) {
      if (e.target.className.indexOf("softKeyboardHide") > -1) {
        document.activeElement.blur();
      }
    });
    store.dispatch("loadSiteInfo").then(function (json) {});
    $("link[rel=icon]").attr("href", __self.getImgs('icon.ico'))
  },
  methods: {
    SaveCookie(value) {
      document.cookie = `lang=${value};path=/;`;
    },
  },
  components: {
    dialogs,
    globalLoading,
    customerServices
  }
}).$mount("#app");
utils.$app = app;
window.$app = app;



// WEBPACK FOOTER //
// ./src/main.js